module.exports = __webpack_public_path__ + "d94e20c1/img/lock-icon.bb9c7166.svg";